import * as icons from './icons';
import { IconName } from './Icon.types';

export const iconNames = Object.keys(icons) as Array<IconName>;

export const isIconName = (icon: string | null | undefined): icon is IconName =>
    iconNames.includes(icon as IconName);
